<template>
  <div>
    <PageHeader title="Contract Templates" buttonLabel="+ New Template" :buttonPath="{ name: 'contract-template-create' }" />

    <div v-if="isLoading" class="text-center py-5"><b-spinner /></div>
    <div v-else-if="!templates.length" class="text-center py-5 text-muted">No templates yet.</div>

    <b-row v-else>
      <b-col v-for="t in templates" :key="t.id" sm="6" lg="4" xl="3" class="mb-3">
        <div class="tpl-card card h-100">
          <div class="card-body d-flex flex-column">
            <div class="d-flex align-items-start justify-content-between mb-2">
              <div>
                <i class="material-icons tpl-card-icon">{{ t.is_pdf_template ? 'picture_as_pdf' : 'description' }}</i>
              </div>
              <b-dropdown right no-caret variant="link" class="row-action-btn">
                <template #button-content><i class="material-icons">more_vert</i></template>
                <b-dropdown-item :to="{ name: 'contract-template-edit', params: { id: t.id } }">
                  <i class="material-icons">edit</i> Edit
                </b-dropdown-item>
                <b-dropdown-item v-if="t.is_pdf_template" @click="openBuilder(t.id)">
                  <i class="material-icons">picture_as_pdf</i> Open Builder
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item class="text-danger" @click="removeTemplate(t.id)">
                  <i class="material-icons">delete</i> Delete
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <router-link :to="{ name: 'contract-template-edit', params: { id: t.id } }" class="tpl-card-title">
              {{ t.name }}
            </router-link>
            <div class="mt-auto pt-2">
              <b-badge v-if="t.is_pdf_template" variant="info">PDF</b-badge>
              <span v-else class="tpl-card-type">HTML</span>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PageHeader from '../../components/Ui/PageHeader.vue';

const SIGN_URL = process.env.VUE_APP_SIGN_URL || 'http://localhost:8084';

export default {
  name: 'ContractTemplatesList',
  components: { PageHeader },
  data() {
    return { templates: [], isLoading: false };
  },
  computed: {
    ...mapGetters('auth', ['getAuthToken']),
  },
  methods: {
    ...mapActions('contractTemplate', ['getAllContractTemplates', 'deleteContractTemplate']),
    async fetchTemplates() {
      this.isLoading = true;
      try { const res = await this.getAllContractTemplates(); this.templates = res.data.results || res.data || []; }
      catch (err) { this.makeToast('danger', 'Failed to load'); }
      finally { this.isLoading = false; }
    },
    async removeTemplate(id) {
      if (!confirm('Delete this template?')) return;
      try { await this.deleteContractTemplate(id); this.fetchTemplates(); } catch (err) { this.makeToast('danger', 'Delete failed'); }
    },
    openBuilder(templateId) {
      window.open(`${SIGN_URL}/template-builder/${templateId}?token=${this.getAuthToken}`, '_blank');
    },
  },
  created() { this.fetchTemplates(); },
};
</script>

<style scoped>
.tpl-card { transition: box-shadow 0.15s; }
.tpl-card:hover { box-shadow: 0 0.25rem 2rem rgba(58,59,69,0.2); }
.tpl-card-icon { font-size: 28px; color: #868e96; }
.tpl-card-title {
  font-weight: 600; font-size: 0.95rem; color: #272C33;
  text-decoration: none; line-height: 1.4;
}
.tpl-card-title:hover { color: var(--primary-color); }
.tpl-card-type { font-size: 0.75rem; color: #868e96; }
</style>
